import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[90vh] flex items-center overflow-hidden">
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(135deg, oklch(0.06 0.002 275) 0%, oklch(0.12 0.02 25) 50%, oklch(0.18 0.06 40) 100%)',
        }}
      ></div>

      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-background-50/80"></div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 pt-20 pb-12">
        <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-16">
          <div className="lg:w-[60%] space-y-6">
            <span className="inline-flex items-center gap-1.5 px-4 py-1.5 bg-primary-500/15 text-primary-400 text-xs font-medium rounded-full border border-primary-500/20">
              <i className="ri-fire-line text-sm"></i>
              热门韩漫推荐
            </span>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-50 leading-tight tracking-tight">
              韩漫屋
              <br />
              <span className="text-primary-500">韩漫在线阅读</span>
              <br />
              免费韩国漫画大全
            </h1>

            <p className="text-base md:text-lg text-foreground-300 max-w-lg leading-relaxed">
              在韩漫屋体验舒适的韩漫在线阅读，免费韩国漫画大全任您浏览，所有<strong className="text-primary-400 font-medium">无删减下拉式韩漫</strong>保证内容的原始风貌。
            </p>

            <div className="flex items-center gap-4 pt-2">
              <Link
                to="/category/romance"
                className="px-7 py-3 text-sm font-semibold bg-primary-500 text-background-950 rounded-full whitespace-nowrap transition-all duration-200 hover:bg-primary-400 cursor-pointer"
              >
                开始阅读
              </Link>
              <Link
                to="/about"
                className="text-sm font-medium text-foreground-300 border-b border-primary-500/50 pb-0.5 whitespace-nowrap transition-colors hover:text-primary-400 hover:border-primary-400"
              >
                了解更多
              </Link>
            </div>
          </div>

          <div className="lg:w-[40%] flex items-start justify-center lg:justify-end mt-6 lg:mt-0">
            <div className="relative">
              <div className="absolute -inset-1 bg-primary-500/10 rounded-3xl blur-2xl"></div>
              <div className="relative w-64 h-80 md:w-72 md:h-96 rounded-2xl overflow-hidden border border-background-200/40">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20romantic%20couple%20in%20dramatic%20embrace%20with%20warm%20golden%20backlight%2C%20cinematic%20lighting%2C%20emotional%20intense%20atmosphere%2C%20anime%20art%20style%2C%20beautiful%20composition%2C%20soft%20glow%20effects%2C%20clean%20dark%20background&width=800&height=1067&seq=hero-featured-comic&orientation=portrait"
                  alt="韩漫屋热门推荐漫画 - 韩漫在线阅读"
                  title="韩漫屋热门推荐漫画 - 韩漫在线阅读"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <span className="text-xs text-primary-400 bg-primary-500/15 px-2 py-0.5 rounded-full">本周热门</span>
                  <p className="text-foreground-50 font-semibold text-base mt-2">她的秘密教学</p>
                  <p className="text-foreground-400 text-xs mt-1">4.8分 · 128万人气</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-14">
          <div className="relative w-full h-48 md:h-64 rounded-2xl overflow-hidden border border-background-200/30">
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20panoramic%20banner%20featuring%20multiple%20character%20silhouettes%20in%20dramatic%20poses%20against%20dark%20atmospheric%20background%2C%20warm%20orange%20and%20deep%20black%20gradient%2C%20cinematic%20composition%2C%20manga%20panel%20style%20layout%2C%20anime%20art%20style%2C%20epic%20wide%20format%2C%20dark%20vignette%20edges&width=1600&height=400&seq=hero-banner-strip&orientation=landscape"
              alt="韩漫屋 - 免费韩国漫画大全 无删减下拉式韩漫"
              title="韩漫屋 - 免费韩国漫画大全"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-background-950/40 to-transparent"></div>
            <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 to-transparent"></div>
          </div>
        </div>
      </div>
    </section>
  );
}